
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 26.6 23.7"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.6 5.6c-.6-.7-1.3-1.3-2.1-1.7a8.18 8.18 0 00-7.6-.5C11.7-.5 5.7-1.4 2.1 2.5.3 4.5-.4 7.1.2 9.7c.6 2.8 2.6 5.3 4.2 7.5 1.4 2 3.2 4.1 4.4 6 .2.5.7.8 1.2.8.2 0 .4-.1.5-.3 1.8-.9 3.7-1.6 5.5-2.5 2.6-1.2 5.6-2.2 7.7-4.1 3.4-3 3.8-8.1.9-11.5zM23.3 15c-1.1 1.2-2.4 2.1-3.9 2.8-1.4.8-3 1.5-4.4 2.1-1.7.8-3.5 1.5-5.1 2.3-1-1.5-2.1-2.9-3.2-4.4-.9-1.3-1.9-2.7-2.8-3.9C3 12.6 2.3 11.1 2 9.5c-.4-3.1 1.2-6 4-7.3C8.8 1 12.2 2 13.8 4.6c.3.6 1 .9 1.6.6 2.7-1.6 6.1-1 8.1 1.4 1.8 2.6 1.7 6-.2 8.4z","fill":"#fff"}})])
          )
        }
      }
    